import { render, staticRenderFns } from "./toAsk.vue?vue&type=template&id=5d9d72d0&scoped=true"
import script from "./toAsk.vue?vue&type=script&lang=js"
export * from "./toAsk.vue?vue&type=script&lang=js"
import style0 from "./toAsk.vue?vue&type=style&index=0&id=5d9d72d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9d72d0",
  null
  
)

export default component.exports